<template>
  <div class="lang-switch">
    <button type="button" class="lang-trigger" @click="open = !open">
      <img v-if="flagUrl(current)" class="flag-img" :src="flagUrl(current)" :alt="current.label" />
      <span v-else class="flag">{{ flagText(current) }}</span>
      <span class="label">{{ current.label }}</span>
      <svg class="caret" :class="{ open }" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>

    <template v-if="open">
      <div class="lang-backdrop" @click="open = false"></div>
      <ul class="lang-menu">
        <li
          v-for="opt in options"
          :key="opt.code"
          :class="{ active: opt.code === $langCode }"
          @click="choose(opt.code)"
        >
          <img v-if="flagUrl(opt)" class="flag-img" :src="flagUrl(opt)" :alt="opt.label" />
          <span v-else class="flag">{{ flagText(opt) }}</span>
          <span class="label">{{ opt.label }}</span>
          <svg v-if="opt.code === $langCode" class="tick" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 13l4 4L19 7" />
          </svg>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { i18nState, getLocaleMeta } from "../i18n";

// 后台的 flag 字段形态未定：图片地址 / 旗帜 emoji / 两位国家码，三种都兼容
const ISO2 = /^[A-Za-z]{2}$/;

export default {
  name: "LangSwitch",
  data() {
    return { open: false };
  },
  computed: {
    // 清单来自 /api/index/languages，拉不到时是内置兜底列表
    options() {
      return i18nState.list;
    },
    current() {
      return getLocaleMeta(this.$langCode);
    },
  },
  methods: {
    flagUrl(opt) {
      const f = (opt && opt.flag) || "";
      return /^(https?:)?\/\//.test(f) || f.charAt(0) === "/" ? f : "";
    },
    flagText(opt) {
      const f = ((opt && opt.flag) || "").trim();
      if (!f) return "";
      // 两位国家码转成 regional indicator 旗帜
      if (ISO2.test(f)) {
        return String.fromCodePoint(
          ...f.toUpperCase().split("").map((c) => 0x1f1a5 + c.charCodeAt(0))
        );
      }
      return f;
    },
    choose(code) {
      this.$setLocale(code);
      this.open = false;
    },
  },
};
</script>

<style scoped>
.lang-switch {
  position: relative;
}

.lang-trigger {
  border: 0;
  background: transparent;
  color: #c7ccd6;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* 旗帜用 emoji，桌面端字体缺失时会退化成国家字母，移动端钱包浏览器正常显示 */
.flag {
  font-size: 16px;
  line-height: 1;
  flex: none;
}

/* 后台 flag 返回图片地址时走这里 */
.flag-img {
  width: 20px;
  height: 14px;
  flex: none;
  object-fit: cover;
  border-radius: 2px;
}

.lang-trigger .label {
  max-width: 88px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.caret {
  width: 15px;
  height: 15px;
  stroke: #9aa3b2;
  stroke-width: 2.4;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.15s;
}

.caret.open {
  transform: rotate(180deg);
}

.lang-backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.lang-menu {
  position: absolute;
  top: 130%;
  left: 0;
  z-index: 41;
  margin: 0;
  padding: 6px;
  list-style: none;
  min-width: 152px;
  max-height: 62vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background: rgba(12, 17, 34, 0.82);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid var(--pool-line);
  border-radius: 12px;
  box-shadow: 0 18px 40px -14px rgba(0, 0, 0, 0.7);
}

.lang-menu li {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 12px;
  border-radius: 7px;
  color: #c7ccd6;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.lang-menu li:hover {
  background: #232c40;
}

.lang-menu li.active {
  color: var(--pool-teal);
  font-weight: 600;
}

.lang-menu li .label {
  flex: 1;
}

.tick {
  width: 15px;
  height: 15px;
  flex: none;
  stroke: currentColor;
  stroke-width: 2.6;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
